<ng-container *ngIf="inlineEditor else popupEditor">
    <se-letter-cell-editor-inline tabindex="0"
                                  [value]="value"
                                  [notAdmissibleChars]="notAdmissibleChars"
                                  [required]="required"
                                  [startEdited]="cellStartEdited"
                                  (formReady)="_onFormReady($event)">
    </se-letter-cell-editor-inline>
</ng-container>

<ng-template #popupEditor>
    <se-letter-cell-editor-popup tabindex="0"
                                 [value]="value"
                                 [notAdmissibleChars]="notAdmissibleChars"
                                 [required]="required"
                                 [width]="cellWidth"
                                 (formReady)="_onFormReady($event)">
    </se-letter-cell-editor-popup>
</ng-template>
